module.exports = __webpack_public_path__ + "static/media/back-button-inverted.f4eb553e.svg";